(ns frontend.view.modals.custom-entity-creator.view
  (:require
   [ui.view.entity-creator.view :as entity-creator]
   [ui.view.entity-creator.opportunity.view :as opportunity-creator]
   [ui.view.entity-creator.investor.view :as investor-creator]))

;; Note: modal-keys in frontend.view.modals.custom-entity-creator.model
;; to prevent circular dependencies

(defn view
  [props]
  ;;[entity-creator/modal-view props]
  [entity-creator/curtain-view props])

(defn opportunity-curtain-view
  [props]
  [opportunity-creator/curtain props])

(defn investor-curtain-view
  [props]
  [investor-creator/curtain props])
